module.exports = __webpack_public_path__ + "static/FloatingFile-1-light-773387d1fcecfc53088fa0a14407388e.svg";